import ConfigurationOptions from '../layouts/ConfigurationOptions.jsx';
import ConfigurationTableSearch, { parameterTableRows } from './ConfigurationTableSearch';
import ClassifierFields, { classifierSettings, classifierError, classifierOutputOptions } from './ClassifierFields';
import React, { useState, useEffect, useRef } from 'react';
import server from '../../api/server.js';
import "../loader.css"
import { X, Info, Save, Upload, Download } from 'lucide-react';
import { FaRegEdit, FaTimes } from "react-icons/fa";
import ExpandableParametersComponent from '../layouts/agentFeedbackLayout.jsx'
import ModernTimeDropdown from '../layouts/modernDropdown.jsx';
import { useToast } from '../../context/ToastContext.jsx';
import SampleTestModal from '../layouts/SampleTestModal.jsx'
import { IoChatbubbleOutline } from 'react-icons/io5';
import { Sparkles, Wand2 } from 'lucide-react';
import FeedbackSection from '../layouts/FeedbackSection.jsx';
import DeployConfirmationModal from '../layouts/DeployConfirmationModal.jsx';
import { getApiToastMessage } from '../../utils/apiToastMessage.js';
import { findBoundarySpaceName, hasBoundarySpace, getBoundarySpaceNameError } from '../../utils/moduleNameValidation.js';
import ConfigurationDiffButton from '../layouts/ConfigurationDiffButton.jsx';

const callTypeOptions = [
  ['run_for_non_meaningful_calls', 'Non-Meaningful calls'],
  ['run_for_not_connected_calls', 'Not Connected calls'],
];
const callTypeSettings = (value = {}) => Object.fromEntries(
  callTypeOptions.filter(([key]) => value[key] !== undefined).map(([key]) => [key, value[key]])
);

const moduleCallTypeSettings = (value = {}) => Object.fromEntries(
  callTypeOptions.map(([key]) => [key, value[key] ?? 1])
);

const configWithExecutionSettings = (configuration, settings) => ({
  configuration,
  ...moduleCallTypeSettings(settings),
});

const LeadQualityConfigure = ({clientID, serviceID, module_name, setCloseModal, config_data}) => {
  const [moduleExecution, setModuleExecution] = useState(moduleCallTypeSettings());
  const [loadedModuleExecution, setLoadedModuleExecution] = useState(moduleCallTypeSettings());
  const [parameterExecution, setParameterExecution] = useState({});
  const [tableSearch, setTableSearch] = useState({});
  const { showToast } = useToast();
  const [showPreview, setShowPreview] = useState(false);
  const [showDeployConfirmation, setShowDeployConfirmation] = useState(false);
  const [current_version, setCurrent_version] = useState(0)
  const [expandedSample, setExpandedSample] = useState(false)
  const [activeTab, setActiveTab] = useState('conversationPotential');
  const [subparameters, setSubparameters] = useState([])
  const [isValid, setIsValid] = useState(false)
  const [isValidQuery, setIsValidQuery] = useState(false)
  const [possibleValues, setPossibleValues] = useState([])
  const [possibleValue, setPossibleValue] = useState('')
  const [possibleValuesQuery, setPossibleValuesQuery] = useState([])
  const [possibleValueQuery, setPossibleValueQuery] = useState('')
  const [showSampleTest, setShowSampleTest] = useState(false)
  const [showSampleTestModal, setShowSampleTestModal] = useState(false)
  const [logicExplanationConvoPotential, setLogicExplanationConvoPotential] = useState('')
  const [logicExplanationCustomerPotential, setLogicExplanationCustomerPotential] = useState('')
  const [writeWithAiEnabledConvoPotential, setWriteWithAiEnabledConvoPotential] = useState(false)
  const [writeWithAiEnabledCustomerPotential, setWriteWithAiEnabledCustomerPotential] = useState(false)
  const [promptQueryConvoPotential, setPromptQueryConvoPotential] = useState('')
  const [promptQueryCustomerPotential, setPromptQueryCustomerPotential] = useState('')
  const [logicLoading, setLogicLoading] = useState(false)
  const [parameters, setParameters] = useState([]);
  const [agentFeedbackModule, setAgentFeedbackModule] = useState(null)
  const [criteria, setCriteria] = useState(null)
  const [defaultActive, setDefaultActive] = useState(false)
  const [moduleDraftSaveConfiguration, setModuleDraftSaveConfiguration] = useState(null)
  const [configType, setConfigType] = useState('Live Version')
  const [showConfigDropdown, setShowConfigDropdown] = useState(false)
  const [showDropdown, setShowDropdown] = useState(false);
  const dropdownRef = useRef(null);
  const inputRef = useRef(null);
  const segmentRefs = useRef([]);
  const audioRef = useRef(null);
  const [selectedSegmentIdx, setSelectedSegmentIdx] = useState(null);
  const [showMoreMap, setShowMoreMap] = useState({});
  const sourceClickInProgressRef = useRef(false);
  const [subparameters_used, setSubparameters_used] = useState([])
  const [role] = useState(()=> {
    const userCookie = getCookie('dashboard_login_user_creds');
    if (userCookie) {
      const userData = JSON.parse(userCookie);
      const role = userData.role
      return role
    }
    return 'admin';
  })
  const [descriptionError, setDescriptionError] = useState(null)
  const [showLoadConfigurePart, setShowLoadConfigurePart] = useState(false)
  
  // Upload and Download Configuration Functions
  const handleDownloadConfig = () => {
    try {
      const configData = {
        subparameters: subparameters.map(subparam => ({
          display_name: subparam.display_name,
          output_type: subparam.output_type || 'Yes/No',
          system: subparam.system || 0,
          instruction: subparam.instruction || '',
          ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation', ...callTypeSettings(subparam) } : {}),
          ...classifierSettings(subparam),
          possible_values: subparam.possible_values || [],
          archived: subparam.archived || false
        })),
        'conversation_potential_query': manualQuery,
        'customer_potential_query': manualQueryQuery,
        ...moduleExecution, moduleActive: moduleActive
      };

      const blob = new Blob([JSON.stringify(configData, null, 2)], { type: 'application/json' });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `lead_quality_config_${new Date().toISOString().split('T')[0]}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      
      showToast('Configuration downloaded successfully!', 'success');
    } catch (error) {
      console.error('Error downloading configuration:', error);
      showToast('Error downloading configuration', 'error');
    }
  };

  const handleUploadConfig = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onload = async (e) => {
      try {
        const configData = JSON.parse(e.target.result);
        setPossibleValues([])
        setPossibleValuesQuery([])
        setLoading(true)
        const uploadedSubparameters = configData.subparameters || [];
        const boundarySpaceError = findBoundarySpaceName(uploadedSubparameters, 'display_name', 'Subparameter name');
        if (boundarySpaceError) {
          showToast(boundarySpaceError, 'error');
          setLoading(false);
          event.target.value = '';
          return;
        }
        const validationConfig = {
          configuration: {
            'conversation_potential': {
              'overall': {
                'logic': configData.conversation_potential_query,
                'logic_explanation': '',
                'output_type': 'Categorical',
                'display_name': 'Conversation Potential',
                'possible_values': configData.possible_values || configData.conversation_potential_possible_values || []
              },
              'subparameters': uploadedSubparameters.reduce((acc, subparam) => {
                acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
                  output_type: subparam.output_type || 'Yes/No',
                  system: subparam.system || 0,
                  instruction: subparam.instruction || '',
                  ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation', ...callTypeSettings(subparam) } : {}),
                  ...classifierSettings(subparam),
                  display_name: subparam.display_name,
                  possible_values: subparam.possible_values || []
                };
                return acc;
              }, {}),
              'subparameters_used': uploadedSubparameters.map((subparam) => subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_'))
            },
            'customer_potential': {
              'overall': {
                'logic': configData.customer_potential_query,
                'logic_explanation': '',
                'output_type': 'Categorical',
                'display_name': 'Customer Potential',
                'possible_values': configData.customer_potential_possible_values || []
              },
              'subparameters': customerPotentialSubparameters.reduce((acc, subparam) => {
                acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
                  output_type: subparam.output_type || 'Yes/No',
                  system: subparam.system || 0,
                  instruction: subparam.instruction || '',
                  ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation' } : {}),
                  ...classifierSettings(subparam),
                  display_name: subparam.display_name,
                  possible_values: subparam.possible_values || []
                };
                return acc;
              }, {})
            }
          },
          ...moduleCallTypeSettings(configData), active: configData.moduleActive === true ? 1 : 0
        };
        const validationResp = await server.validateModuleJsonConfiguration({client_id, service_id: Array.isArray(service_id) ? service_id[0] : service_id, email, menu: 'apps', submenu: undefined, module_name: 'lead_quality', configuration: validationConfig});
        if (validationResp.status !== 200) {
          showToast(await getApiToastMessage(validationResp, 'Invalid configuration'), 'error')
          setLoading(false)
          event.target.value = '';
          return;
        }
        
        // Validate the uploaded configuration
        if (!configData.subparameters || !configData.conversation_potential_query || !configData.customer_potential_query) {
          throw new Error('Invalid configuration format');
        }
        
        if (configData.subparameters) {
          setSubparameters(configData.subparameters);
        }
        setManualQuery(configData.conversation_potential_query)
        setManualQueryQuery(configData.customer_potential_query)
        setSubparameters_used(configData.subparameters.map((subparam) => subparam.display_name.toLowerCase().replaceAll(" ", '_')))
        setIsValid(true)
        setIsValidQuery(true)
        
        if (configData.moduleActive !== undefined) {
          setModuleActive(configData.moduleActive);
        }
        setModuleExecution(moduleCallTypeSettings(configData));

        showToast(await getApiToastMessage(validationResp, 'Configuration uploaded successfully!'), 'success');
        setLoading(false)
      } catch (error) {
        console.error('Error parsing uploaded configuration:', error);
        showToast('Error uploading configuration: Invalid JSON format', 'error');
        setLoading(false)
      }
    };
    
    reader.readAsText(file);
  };

  const toggleShowMore = (key) => {
    setShowMoreMap(prev => ({ ...prev, [key]: !prev[key] }));
  };
  const convertToSeconds = (time) => {
    if(typeof time === 'string'){
      const [hours, minutes, seconds] = time.split(':').map(Number);
      return (hours * 3600) + (minutes * 60) + seconds;
    }
    return time;
  }
  const handleSourceClick = (source, segments) => {
    let start, end, message_id;
    if(source.start_timestamp && source.end_timestamp){
      // Set flag to prevent automatic segment selection
      sourceClickInProgressRef.current = true;
      
      // Convert timestamps to seconds with proper validation
      try {
        if(typeof source.start_timestamp === 'string'){
          start = convertToSeconds(source.start_timestamp)-1;
        }else{
          start = parseFloat(source.start_timestamp)-1;
        }
        if(typeof source.end_timestamp === 'string'){
          end = convertToSeconds(source.end_timestamp)+1;
        }else{
          end = parseFloat(source.end_timestamp)+1;
        }
        
        // Validate that start and end are valid numbers
        if (isNaN(start) || isNaN(end)) {
          console.warn('Invalid timestamp values:', source.start_timestamp, source.end_timestamp);
          sourceClickInProgressRef.current = false;
          return;
        }
        
        // Ensure start time is always less than end time
        if (start >= end) {
          console.warn('Start time must be less than end time:', start, end);
          sourceClickInProgressRef.current = false;
          return;
        }
        
      } catch (error) {
        console.warn('Error converting timestamps:', error);
        sourceClickInProgressRef.current = false;
        return;
      }
      
      // Handle audio case
      // Check if audio element exists and is valid
      if (!audioRef.current) {
        console.warn('Audio element not available');
        sourceClickInProgressRef.current = false;
        return;
      }

      try {
        // Pause any currently playing audio first
        audioRef.current.pause();
        
        // Remove any existing timeupdate listeners
        if (audioRef.current._currentTimeUpdateHandler) {
          audioRef.current.removeEventListener('timeupdate', audioRef.current._currentTimeUpdateHandler);
          audioRef.current._currentTimeUpdateHandler = null;
        }
        
        // Create new timeupdate handler
        const timeUpdateHandler = () => {
          if (!audioRef.current) return;
          
          const currentTime = audioRef.current.currentTime;
          
          if (currentTime >= end) {
            audioRef.current.pause();
            audioRef.current.removeEventListener('timeupdate', timeUpdateHandler);
            audioRef.current._currentTimeUpdateHandler = null;
          }
        };
        
        // Store reference to handler for cleanup
        audioRef.current._currentTimeUpdateHandler = timeUpdateHandler;
        
        // Add the new listener
        audioRef.current.addEventListener('timeupdate', timeUpdateHandler);
        
        // Seek to start time
        audioRef.current.currentTime = start;
        
        // Play with proper error handling
        const playPromise = audioRef.current.play();
        if (playPromise !== undefined) {
          playPromise
            .then(() => {
              // Find the segment index whose range includes the start time
              let idx = 0;
              for (let i = 0; i < segments.length; i++) {
                if (start >= segments[i].start_time && start <= segments[i].end_time) {
                  idx = i;
                  break;
                }
              }
              setSelectedSegmentIdx(idx);
              
              // Scroll the segment into view
              if (segmentRefs.current[idx] && idx === selectedSegmentIdx) {
                segmentRefs.current[idx].scrollIntoView({ behavior: "smooth", block: "nearest" });
              }
              
              // Clear the flag after successful playback start
              sourceClickInProgressRef.current = false;
            })
            .catch(error => {
              console.warn('Error playing audio:', error);
              // Clean up listener on error
              audioRef.current.removeEventListener('timeupdate', timeUpdateHandler);
              audioRef.current._currentTimeUpdateHandler = null;
              // Clear the flag on error
              sourceClickInProgressRef.current = false;
            });
        }
      } catch (error) {
        console.warn('Error handling source click:', error);
        sourceClickInProgressRef.current = false;
      }
    } else {
      // Handle chat message case
      message_id = source.segment_id;
      if(message_id){
        const message = segments.find(message => message.message_id === message_id);
        if(message){
          // Find the index of the message in chatTranscriptions
          const messageIndex = segments.findIndex(msg => msg.message_id === message_id);
          if (messageIndex !== -1) {
            // Create a ref for the message element if it doesn't exist
            if (!segmentRefs.current[messageIndex]) {
              segmentRefs.current[messageIndex] = React.createRef();
            }
            
            // Scroll the message into view
            setTimeout(() => {
              const messageElement = document.querySelector(`[data-message-id="${message_id}"]`);
              if (messageElement) {
                messageElement.scrollIntoView({ behavior: "smooth", block: "nearest" });
                // Add a temporary highlight effect
                messageElement.style.backgroundColor = "rgba(111, 111, 254, 0.1)";
                setTimeout(() => {
                  messageElement.style.backgroundColor = "";
                }, 2000);
              }
            }, 100);
          }
        }
      }
    }
  }

  const scrollToSegment = (idx) => {
    const el = segmentRefs.current[idx];
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  };  
  const toggleSegment = (item, idx, link) => {
    setSelectedSegmentIdx(idx);
    scrollToSegment(idx);
    if(!link){
      return;
    }
    if (audioRef.current) {
      audioRef.current.currentTime = item.start_time; // Seek to the start time of the segment
      audioRef.current.play(); // Play the audio
    }
  };
  const formatTime = (timeInSeconds) => {
    const minutes = Math.floor(timeInSeconds / 60);
    const seconds = Math.floor(timeInSeconds % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };
  function formatEpochTime(epochMillis) {
    if (typeof epochMillis !== 'number' || epochMillis.toString().length !== 13) {
      return ""
    }
  
    const date = new Date(epochMillis);
    return date.toLocaleString(); // e.g., "5/29/2025, 2:30:45 PM"
  }
  const handleAudioTimeUpdate = (segments) => {
    if (sourceClickInProgressRef.current) return;
    const currentTime = audioRef.current.currentTime;

    // Find the segment corresponding to the current audio time
    segments.forEach((segment, idx) => {
      if (currentTime >= segment.start_time && currentTime <= segment.end_time) {
        if (segmentRefs.current[idx]) {
          // Scroll the corresponding segment into view if it's not already visible
          segmentRefs.current[idx].scrollIntoView({
            behavior: "smooth",
            block: "nearest",
          });

          // Highlight the selected segment
          setSelectedSegmentIdx(idx);
        }
      }
    });
  };
  const getBorderColor = (actor_type) => {
    switch (actor_type) {
      case 'user':
        return"4px solid #6f6ffe"
      case 'agent':
        return"4px solid #3B82F6"
      case 'bot':
        return"4px solid gray"
      case 'system':
        return "4px solid gray"
      default:
        break;
    }
  }
  const getBackgroundColor = (actor_type) => {
    switch (actor_type) {
      case 'user':
        return"rgb(249, 250, 251)"
      case 'agent':
        return"rgb(249, 250, 251)"
      case 'bot':
        return"rgb(249, 250, 251)"
      case 'system':
        return"rgb(249, 250, 251)"
      default:
        break;
    }
  }

  const handleCloseSampleTestModal = () => {
    setShowSampleTestModal(false)
  }

  const handleAddPossibleValue = () => {
    if (possibleValue.trim()) {
      setPossibleValues([...possibleValues, possibleValue.trim()]);
      setPossibleValue('')
    }
  };
  const handleAddPossibleValueQuery = () => {
    if (possibleValueQuery.trim()) {
      setPossibleValuesQuery([...possibleValuesQuery, possibleValueQuery.trim()]);
      setPossibleValueQuery('')
    }
  };

  const handleRemovePossibleValue = (value) => {
    setPossibleValues(possibleValues.filter(v => v !== value));
  };
  const handleRemovePossibleValueQuery = (value) => {
    setPossibleValuesQuery(possibleValuesQuery.filter(v => v !== value));
  };
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target) &&
          inputRef.current && !inputRef.current.contains(event.target)) {
        setShowDropdown(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);
  

  // Modal states
  const [showSubparameterModal, setShowSubparameterModal] = useState(false);
  const [parameter_name, setParameter_name] = useState('');
  const [loading, setLoading] = useState(false);
  const [manualQuery, setManualQuery] = useState('');
  const [manualQueryQuery, setManualQueryQuery] = useState('')
  const [queryError, setQueryError] = useState('');
  const [queryErrorQuery, setQueryErrorQuery] = useState('')

  // Add these state variables at the top with other states
  const [subparameterName, setSubparameterName] = useState('');
  const [subparameterDefinition, setSubparameterDefinition] = useState('');
  const [contextScope, setContextScope] = useState('conversation');
  const [classification, setClassification] = useState({});
  const [subparameterType, setSubparameterType] = useState('Yes/No/NA');
  const [subparameterTags, setSubparameterTags] = useState([]);
  const [subparameterPossibleValues, setSubparameterPossibleValues] = useState([])
  const [currentTag, setCurrentTag] = useState('');

  // Add this new state near other state declarations
  const [showLogicInfo, setShowLogicInfo] = useState(false);

  const handleEditSubparameter = (id) => {
    setError(null)
    const subparam = subparameters.find(p => p.id === id);
    if (subparam) {
      setSubparameterName(subparam.display_name);
      setSubparameterDefinition(subparam.instruction || '');
      setContextScope(subparam.context_scope || 'conversation');
      setParameterExecution(callTypeSettings(subparam));
      setClassification(classifierSettings(subparam));
      setSubparameterType(subparam.output_type || 'Yes/No/NA');
      // Keep options & possible_values in sync while editing
      const existingOptions = (subparam.options && subparam.options.length > 0) ? subparam.options : (subparam.possible_values || []);
      setSubparameterTags(existingOptions);
      setSubparameterPossibleValues(existingOptions);
      setEditingParameter(subparam);
      setShowSubparameterModal(true);
      setTimeout(() => {
        const element = document.getElementById('editing-parameter');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      }, 100);
    }
  };
  const generateLogicWithAIConvoPotential = async () => {
    try {
      setLogicLoading(true)
      let res = await server.generateLogicWithAI(client_id, service_id, 'apps', undefined, email, promptQueryConvoPotential, JSON.stringify(customerPotentialSubparameters))
      if(res.status === 200){
        let resp = await res.json()
        if(resp.data && resp.data.logic){
          setManualQuery(resp.data.logic)
          await verifyQuery()
        }
      } else {
        setLogicLoading(false)
        // Handle error responses
        let errorResp = await res.json();
        showToast('Failed to generate logic. Please try again later.', 'error');
      }
    } catch (error) {
      setLogicLoading(false)
      showToast('Failed to generate logic. Please try again later.', 'error');
    } finally {
      setLogicLoading(false)
    }
  }
  const generateLogicWithAICustomerPotential = async () => {
    try {
      setLogicLoading(true)
      let res = await server.generateLogicWithAI(client_id, service_id, 'apps', undefined, email, promptQueryCustomerPotential, JSON.stringify(customerPotentialSubparameters))
      
      if(res.status === 200){
        let resp = await res.json()
        if(resp.data && resp.data.logic){
          setManualQueryQuery(resp.data.logic)
          await verifyQueryQuery()
        }
      } else {
        setLogicLoading(false)
        // Handle error responses
        let errorResp = await res.json();
        showToast('Failed to generate logic. Please try again later.', 'error');
      }
    } catch (error) {
      setLogicLoading(false)
      showToast('Failed to generate logic. Please try again later.', 'error');
    } finally {
      setLogicLoading(false)
    }
  }
// Handle changes to the query
const handleQueryChange = (query) => {
  setManualQuery(query);
};
const handleQueryChangeQuery = (query) => {
  setManualQueryQuery(query);
};

const verifyQuery = async () => {
  setLogicLoading(true)
  if (!manualQuery.trim()) {
    setQueryError('Query cannot be empty');
    return false;
  }

  try {
    let selectedSubparameters = []
    for(let i=0;i<subparameters.length;i++){
      selectedSubparameters.push(subparameters[i].display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_'))
    }
    const result = await server.verifyQuery(client_id, service_id, manualQuery, selectedSubparameters, subparameters, 'string', 'subset');
    setLogicLoading(false)
    if (result.status === 200) {
      let resp = await result.json()
      setLogicExplanationConvoPotential(resp.logic_explanation)
      if(resp.errors && resp.errors.length > 0){
        setLogicLoading(false)
        setQueryError(resp.errors[0]['error_type'] + ": " + resp.errors[0]['error_description'])
        return false;
      }else{
        setLogicLoading(false)
        let returnValues = resp.return_values
        // Skip possible values validation for lead_quality module
        if(returnValues.length > 0 && module_name !== 'lead_quality') {
          const cleanedReturnValues = returnValues.map(value => value.replace(/'/g, '').toLowerCase());
          const possibleValuesLower = possibleValues.map(value => value.toLowerCase());
          
          const hasInvalidValue = cleanedReturnValues.some(value => !possibleValuesLower.includes(value));
          
          if(hasInvalidValue) {
            setQueryError('Possible values does not match.')
            return false;
          }
        }
        setQueryError('');
        setIsValid(true);
        setManualQuery(resp.formatted)
        setSubparameters_used(resp.subparameters)
        return true;
      }
    } else {
      setLogicLoading(false)
      setQueryError(result.errorResponse.error);
      return false;
    }
  } catch (error) {
    setLogicLoading(false)
    setQueryError('Error verifying query');
    return false;
  }
};
const verifyQueryQuery = async () => {
  setLogicLoading(true)
  if (!manualQueryQuery.trim()) {
    setQueryErrorQuery('Query cannot be empty');
    return false;
  }

  try {
    let selectedSubparameters = []
    for(let i=0;i<customerPotentialSubparameters.length;i++){
      selectedSubparameters.push(customerPotentialSubparameters[i].display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_'))
    }
    const result = await server.verifyQuery(client_id, service_id, manualQueryQuery, selectedSubparameters, customerPotentialSubparameters, 'string', 'subset');
    setLogicLoading(false)
    if (result.status === 200) {
      let resp = await result.json()
      setLogicExplanationCustomerPotential(resp.logic_explanation)
      if(resp.errors && resp.errors.length > 0){
        setLogicLoading(false)
        setQueryErrorQuery(resp.errors[0]['error_type'] + ": " + resp.errors[0]['error_description'])
        return false;
      }else{
        setLogicLoading(false)
        setQueryErrorQuery('');
        setIsValidQuery(true);
        setManualQueryQuery(resp.formatted)
        return true;
      }
    } else {
      setLogicLoading(false)
      setQueryErrorQuery(result.errorResponse.error);
      return false;
    }
  } catch (error) {
    setLogicLoading(false)
    setQueryErrorQuery('Error verifying query');
    return false;
  }
};

const [error, setError] = useState("")
  const handleChangeParams = (e, type) => {
    const value = e.target.value;
    const alphanumericWithSpaceRegex = /^[a-zA-Z0-9 ]*$/;
    
    if (!alphanumericWithSpaceRegex.test(value)) {
      setError("Only alphanumeric characters and spaces are allowed");
      return;
    }
    
    if (value.length <= 30) {
      switch (type) {
        case 'parameter':
          setParameter_name(value)
          break;
        case 'subparameter':
          setSubparameterName(value)
        default:
          break;
      }
      setError(""); // Clear error when within limit
    } else {
      setError("Maximum 30 characters allowed");
    }
};

const customerPotentialSubparameters = [
  {display_name: 'Conversation Potential',output_type: 'String',system: 1,instruction: 'Potential of current conversation',possible_values: []},
  {display_name: 'Previous Customer Potential',output_type: 'String',system: 1,instruction: 'Aggregated Customer Potential till previous conversation',possible_values: []},
  {display_name: 'Count of Conversations',output_type: 'Number',system: 1,instruction: 'Potential of current conversation',possible_values: []},
  {display_name: 'Count of Inbound Conversations',output_type: 'Number',system: 1,instruction: 'Number of meaningful inbound conversations',possible_values: []},
  {display_name: 'Consecutive Inbound Conversations',output_type: 'Number',system: 1,instruction: 'Recent Inbound Conversations streak',possible_values: []},
  {display_name: 'Count of Non Meaningful and Not Connected Conversations',output_type: 'Number',system: 1,instruction: 'Count of Non Meaningful and Not Connected Conversation',possible_values: []},
  {display_name: 'Consecutive Non Meaningful and Not Connected Conversations',output_type: 'Number',system: 1,instruction: 'Recent Non Meaningful and Not Connected Conversations streak',possible_values: []},
  {display_name: 'Count of Distinct Days with consecutive not connected and non meaningful calls', output_type: 'Number', system: 1, instruction: 'Count of Distinct Days with consecutive not connected and non meaningful calls', possible_values: []},
  {display_name: 'Days Since Last Call',output_type: 'Number',system: 1,instruction: 'Days since last conversation and current conversation',possible_values: []},
  {display_name: 'Trigger Initiated', output_type: 'Yes/No/NA', system: 1, instruction: 'Whether a trigger initiated this record - default is no', possible_values: ['Yes','No','NA']},
  {display_name: 'Trigger Type', output_type: 'Text', system: 1, instruction: 'Type of the trigger ', possible_values: []},
  {display_name: 'Trigger Time', output_type: 'Number', system: 1, instruction: 'Trigger time (epoch seconds)', possible_values: []},
  {display_name: 'Trigger Event Time', output_type: 'Number', system: 1, instruction: 'Event time associated with the trigger (epoch seconds)', possible_values: []},
]

const [email, setEmail] = useState(null)
  const [client_id, setClient_id] = useState(null)
  const [service_id, setService_id] = useState(null)
  const [moduleName, setModuleName] = useState(null)
  const [moduleActive, setModuleActive] = useState(false)
  const [editingParameter, setEditingParameter] = useState(null);

  function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }
  const handleAddSubparameter = () => {
    setClassification({});
    setError(null)
    setShowSubparameterModal(true);
    // Smooth scroll to the editing element
    setTimeout(() => {
      const element = document.getElementById('editing-parameter');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
    }, 100);
  };
  const [samples, setSamples] = useState([]);
  const [defaultConfig, setDefaultConfig] = useState(null)

  const generateSamples = async (sample_flag) => {
    try {
      setLoading(true);
      
      // Transform the current state into the required configuration structure
      const config = {
        configuration: {
          'conversation_potential': {
            'overall': {
              'logic': manualQuery,
              'output_type': 'Categorical',
              'display_name': 'Conversation Potential',
              'possible_values': possibleValues
            },
            'subparameters': subparameters.reduce((acc, subparam) => {
              acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
                output_type: subparam.output_type || 'Yes/No',
                system: subparam.system || 0,
                instruction: subparam.instruction || '',
                ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation', ...callTypeSettings(subparam) } : {}),
                ...classifierSettings(subparam),
                display_name: subparam.display_name,
                possible_values: subparam.possible_values
              };
              return acc;
            }, {}),
            'subparameters_used': subparameters_used
          },
          'customer_potential': {
            'overall': {
              'logic': manualQueryQuery,
              'output_type': 'Categorical',
              'display_name': 'Customer Potential',
              'possible_values': possibleValuesQuery
            },
            'subparameters': customerPotentialSubparameters.reduce((acc, subparam) => {
              acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
                output_type: subparam.output_type || 'Yes/No',
                system: subparam.system || 0,
                instruction: subparam.instruction || '',
                ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation' } : {}),
                ...classifierSettings(subparam),
                display_name: subparam.display_name,
                possible_values: subparam.possible_values
              };
              return acc;
            }, {})
          }
        },
        ...moduleExecution, active: moduleActive===true ? 1 : 0
      };

      const response = await server.generateSampleModuleOutputs({
        client_id: client_id,
        service_id: Array.isArray(service_id) ? service_id[0] : service_id,
        module_name: 'lead_quality',
        configuration: config,
        menu: "apps",
        submenu: undefined,
        email: email,
        'sample_set_flag': sample_flag
      });

      const resp = await response.json();
      if (response.status === 200) {
        // Transform the data into the format we need
        const transformedSamples = resp.data.map(sample => {
          return {
            call_id: sample.call_id,
            employee_name: sample.employee_name,
            call_time: sample.call_time,
            name: sample.name,
            parameters: sample.processed_analytics.parameters,
            record_link: sample.record_link,
            segments: Array.isArray(sample.segments) ? sample.segments : [],
            record_type: sample.record_type
          };
        });
        setSamples(transformedSamples);
        setLoading(false);
      }
    } catch (error) {
      console.error("Error generating samples:", error);
      setLoading(false);
    }
  };
  const getDefaultModuleConfigs = async () => {
    try {
      setLoading(true);
      let res = await server.getDefaultModuleConfiguration(client_id, service_id, email, 'apps', undefined, moduleName)
      if(res.status === 200){
        let resp = await res.json()
        if (resp.data){
          setDefaultConfig(resp.data)
        }
      }
    setLoading(false)
    } catch (error) {
      setLoading(false)
    }
  }
  const getProjectStatus = async () => {
    try {
      let res = await server.getProjectStatus(client_id, service_id, email, 'apps', undefined, window.location.href)
      if(res.status === 200){
        let resp = await res.json()
        if(resp.data && resp.data === 'completed'){
          setShowSampleTest(true);
        }
      }
    } catch (error) {
    }
  }

  const getModuleConfig = async() => {
    try {
      let res = await server.getClientModuleConfig(client_id, service_id,email,'apps',undefined, moduleName);
      if(res.status === 200){
        let resp = await res.json()
        let configData = (resp.data?.configuration?.configuration) ? resp.data.configuration.configuration : resp.data.configuration;
        setCurrent_version(resp.data.version)
        setModuleDraftSaveConfiguration(resp.data)
        function transformParameters(params) {
            return Object.keys(params).map((key, index) => ({
                id: index + 1,
                ...params[key]
            }));
        }
        let selectedsubParameters = configData?.conversation_potential.subparameters 
                    ? transformParameters(configData.conversation_potential.subparameters) 
                    : [];
        setManualQuery(configData?.conversation_potential?.overall?.logic || '')
        setManualQueryQuery(configData?.customer_potential?.overall?.logic || '')
        setLogicExplanationConvoPotential(configData?.conversation_potential?.overall?.logic_explanation || '')
        setLogicExplanationCustomerPotential(configData?.customer_potential?.overall?.logic_explanation || '')
        setSubparameters_used(configData?.conversation_potential?.subparameters_used || [])
        setPossibleValuesQuery(configData?.customer_potential?.overall?.possible_values || [])
        setPossibleValues(configData?.conversation_potential?.overall?.possible_values || [])
        setSubparameters(selectedsubParameters)
        setAgentFeedbackModule(configData);
        setModuleActive(resp.data.active === 1 ? true : false)
        setModuleExecution(moduleCallTypeSettings(resp.data));
        setLoadedModuleExecution(moduleCallTypeSettings(resp.data));
        // setDefaultConfig(resp.data.default.configuration)
      }
    } catch (error) {
    }
  }
  const checkDefinitionValidity = async (definition, type, options) => {
  if(type === 'Categorical' || type === 'Yes/No/NA' || type === 'Number' || type === 'Date and Time'){
      let res = await server.checkDefinitionValidity(client_id, service_id, email, 'apps', undefined, definition, type, options, 'lead_quality')
      let resp = await res.json()
      if(res.status === 200){
        if(resp.data){
          if(resp.data.error){
            return {error: resp.data.error}
          }else{
            return {error: null}
          }
        }
      }else{
        return {error: resp.error}
      }
    }
  }
  const deployModule = async(versionDescription) => {
    try {
      setLoading(true)
      let deployed = false;
      let errorMessage = 'Failed to deploy module';
      const moduleConfig = {
        configuration: {
          'conversation_potential': {
            'overall': {
              'logic': manualQuery,
              'logic_explanation': logicExplanationConvoPotential,
              'output_type': 'Categorical',
              'display_name': 'Conversation Potential',
              'possible_values': possibleValues
            },
            'subparameters': subparameters.reduce((acc, subparam) => {
              acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
                output_type: subparam.output_type || 'Yes/No',
                system: subparam.system || 0,
                instruction: subparam.instruction || '',
                ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation', ...callTypeSettings(subparam) } : {}),
                ...classifierSettings(subparam),
                display_name: subparam.display_name,
                possible_values: subparam.possible_values
              };
              return acc;
            }, {}),
            'subparameters_used': subparameters_used
          },
          'customer_potential': {
            'overall': {
              'logic': manualQueryQuery,
              'logic_explanation': logicExplanationCustomerPotential,
              'output_type': 'Categorical',
              'display_name': 'Customer Potential',
              'possible_values': possibleValuesQuery
            },
            'subparameters': customerPotentialSubparameters.reduce((acc, subparam) => {
              acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
                output_type: subparam.output_type || 'Yes/No',
                system: subparam.system || 0,
                instruction: subparam.instruction || '',
                ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation' } : {}),
                ...classifierSettings(subparam),
                display_name: subparam.display_name,
                possible_values: subparam.possible_values
              };
              return acc;
            }, {})
          }
        },
        ...moduleExecution, active: moduleActive===true ? 1 : 0
      }
      let config = moduleConfig
      let resp = await server.deployModule({client_id, service_id: Array.isArray(service_id) ? service_id[0] : service_id, email, menu: 'apps', submenu: undefined, module_name: 'lead_quality', configuration: config, default: defaultActive, 'version_changed': current_version, version_description: versionDescription})
      if (resp.status === 200) {
        showToast('Module deployed successfully', "success")
        deployed = true;
        setLoading(false)
      }else{
        try {
          const errData = await resp.clone().json();
          errorMessage = errData?.message || errData?.error || errorMessage;
        } catch (_) {}
      }
      if (deployed) {
        setCloseModal()
      } else {
        showToast(errorMessage, 'error');
        setLoading(false)
      }
    } catch (error) {
      showToast('Failed to deploy module', 'error');
      setLoading(false)
    }
  }
  const resetToDefault = () => {
    setDefaultActive(true)
    let configData = defaultConfig.configuration;
    if(!configData){
      showToast('No default configuration found', "error")
      return;
    }
    function transformParameters(params) {
        return Object.keys(params).map((key, index) => ({
            id: index + 1,
            ...params[key]
        }));
    }
    let selectedsubParameters = configData?.conversation_potential.subparameters 
                    ? transformParameters(configData.conversation_potential.subparameters) 
                    : [];
                setManualQuery(configData?.conversation_potential?.overall?.logic)
                setManualQueryQuery(configData?.customer_potential?.overall?.logic)
                setLogicExplanationConvoPotential(configData?.conversation_potential?.overall?.logic_explanation || '')
                setLogicExplanationCustomerPotential(configData?.customer_potential?.overall?.logic_explanation || '')
                setPossibleValueQuery(configData?.customer_potential?.overall?.possible_values)
                setPossibleValues(configData?.conversation_potential?.overall?.possible_values)
                setSubparameters_used(configData?.conversation_potential?.subparameters_used || [])
                setSubparameters(selectedsubParameters)
    setAgentFeedbackModule(configData);
    setModuleActive(true);
    setModuleExecution(moduleCallTypeSettings(defaultConfig || {}));
    setLoadedModuleExecution(moduleCallTypeSettings(defaultConfig || {}));
    setActiveTab('conversationPotential')
    // toast.success('Configuration reset to default')
  }
  const handleSaveSubparameter = async () => {
    setShowLoadConfigurePart(true)
    if (!subparameterName.trim()) {
      showToast('Subparameter name is required', "error");
      setShowLoadConfigurePart(false)
      return;
    }
    if (hasBoundarySpace(subparameterName)) {
      const errorMessage = getBoundarySpaceNameError('Subparameter name', subparameterName);
      setError(errorMessage);
      showToast(errorMessage, "error");
      setShowLoadConfigurePart(false);
      return;
    }
    let subparamName = subparameterName.trim()
    let flag = false;
    for(let i=0;i<subparameters.length;i++){
      if(subparameters[i]['display_name'].toLowerCase() === subparamName && !editingParameter?.id){
        flag = true;
        break;
      }
    }
    if(flag === true){
      setError('Subparameter name already exists.')
      setShowLoadConfigurePart(false)
      return;
    }

    const classifierValue = { ...classification, output_type: subparameterType, possible_values: subparameterPossibleValues, instruction: subparameterDefinition };
    const classificationError = classifierError(classifierValue);
    if (classificationError) {
      showToast(classificationError, 'error');
      setShowLoadConfigurePart(false);
      return;
    }
    const newSubparameter = {
      ...classifierSettings(classifierValue),
      system: editingParameter?.system ?? 0,
      status: editingParameter?.status || 'active',
      id: editingParameter?.id ? editingParameter.id : subparameters.length+1,
      display_name: subparamName,
      instruction: subparameterDefinition,
      context_scope: contextScope,
      ...parameterExecution,
      output_type: subparameterType,
      possible_values: subparameterType === 'Yes/No/NA' ? ['Yes', 'No', 'NA'] : subparameterPossibleValues,
      options: subparameterTags,
    };
  if(classification.subparameter_type !== 'classifier' && (subparameterType === 'Categorical' || subparameterType === 'Yes/No/NA' || subparameterType === 'Number' || subparameterType === 'Date and Time')){
      let flagResponse = await checkDefinitionValidity(subparameterDefinition, subparameterType, subparameterPossibleValues)
      if(flagResponse['error']){
        setDescriptionError(flagResponse['error'])
        showToast(flagResponse['error'], "error")
        return;
      }
    }

    if (editingParameter?.id) {
      // Update existing subparameter
      setSubparameters(prevSubparameters =>
        prevSubparameters.map(p =>
          p.id === editingParameter.id ? newSubparameter : p
        )
      );
      showToast('Subparameter updated successfully', "success");
    } else {
      let flag = false
      for(let i=0; i<subparameters.length; i++){
        if(subparameters[i]['display_name'] === subparameterName){
          flag = true
          break;
        }
      }
      if(flag === true){
        setError('Subparameter name already exists.')
          return;
      }
      setSubparameterName(subparameterName.trim())
      // Add new subparameter
      setSubparameters(prevSubparameters => [...prevSubparameters, newSubparameter]);
      showToast('Subparameter added successfully', "success");
    }

    // Reset form fields
    setSubparameterName('');
    setSubparameterDefinition('');
    setContextScope('conversation');
    setParameterExecution({});
    setSubparameterType('Yes/No/NA');
    setSubparameterPossibleValues([])
    setSubparameterTags([]);
    setEditingParameter(null);
    setShowSubparameterModal(false);
    setShowLoadConfigurePart(false)
  };
  const handleAddTag = () => {
    const newTag = currentTag.trim();
    if (newTag === '') return;
    // Append without overwriting existing options and avoid duplicates
    setSubparameterTags(prev => (prev.includes(newTag) ? prev : [...prev, newTag]));
    setSubparameterPossibleValues(prev => (prev.includes(newTag) ? prev : [...prev, newTag]));
    setCurrentTag('');
  }
  const handleRemoveTag = (tag) => {
    // Remove tag from both lists in a functional way
    setSubparameterTags(prev => prev.filter(t => t !== tag));
    setSubparameterPossibleValues(prev => prev.filter(t => t !== tag));
  }
  const getModuleDraftSaveConfiguration = async () => {
    try {
      let res = await server.getModuleDraftSaveConfiguration(client_id, service_id, email, 'apps', undefined, moduleName)
      if(res.status === 200){
        let resp = await res.json()
        if(resp.data){
          let configData = resp.data.configuration;
          setModuleDraftSaveConfiguration(resp.data)
          setManualQuery(configData?.conversation_potential?.overall?.logic)
          setManualQueryQuery(configData?.customer_potential?.overall?.logic)
          setLogicExplanationConvoPotential(configData?.conversation_potential?.overall?.logic_explanation || '')
          setLogicExplanationCustomerPotential(configData?.customer_potential?.overall?.logic_explanation || '')
          setPossibleValueQuery(configData?.customer_potential?.overall?.possible_values)
          setPossibleValues(configData?.conversation_potential?.overall?.possible_values)
          setSubparameters_used(configData?.conversation_potential?.subparameters_used || [])
          setSubparameters(configData?.conversation_potential?.subparameters || [])
        setModuleActive(resp.data.active === 1 ? true : false)
        setModuleExecution(moduleCallTypeSettings(resp.data));
        setLoadedModuleExecution(moduleCallTypeSettings(resp.data));
        }
        // resetToDefault('draft')
      }else{
        showToast('No saved draft.', "error")
        setConfigType('Live Version')
      }
    } catch (error) {
    }
  }
  // Load new audio when sample changes
  useEffect(() => {
        const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
        if (user && clientID) {
          setEmail(user.email);
          setClient_id(clientID);
        }
        if (serviceID && module_name) {
          setService_id(serviceID);
          setModuleName(module_name)
        }
      }, [clientID, serviceID, module_name]);
    
      useEffect(() => {
        if (client_id && service_id && moduleName && email) {
          getModuleConfig();
          getDefaultModuleConfigs()
          getProjectStatus()
        }
      }, [client_id, service_id, moduleName, email]);
      useEffect(()=> {
        if(configType === 'Saved Draft'){
          getModuleDraftSaveConfiguration();
        }
        if(configType === 'Default'){
          resetToDefault();
        }
        if(configType === 'Live Version' && client_id && service_id && moduleName && email){
          getModuleConfig();
        }
      }, [configType])

      useEffect(()=> {
        if(moduleDraftSaveConfiguration){
          const moduleConfig = { 
            criteria: {'minimum_call_duration': parseInt(criteria?.minimum_call_duration), 'audio_quality_threshold': 'Both parties interacted atleast once.'},
            parameters: parameters?.reduce((acc, param) => {
              acc[param.display_name.toLowerCase().replace(/\s+/g, '_')] = {
                fatal: param.fatal || 0,
                logic: param.logic || '',
                weightage: parseInt(param.weightage) || 0,
                display_name: param.display_name,
                subparameters_used: param.subparameters_used || [],
                output_type: 'Number',
                threshold_score: parseInt(param.threshold_score) || 0
              };
              return acc;
            }, {}),
            subparameters: subparameters?.reduce((acc, subparam) => {
              acc[subparam.display_name.toLowerCase().replace(/[\s-\/]+/g, '_')] = {
                output_type: subparam.output_type || 'Yes/No',
                system: subparam.system || 0,
                instruction: subparam.instruction || '',
                ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation', ...callTypeSettings(subparam) } : {}),
                ...classifierSettings(subparam),
                display_name: subparam.display_name,
                possible_values: subparam.possible_values
              };
              return acc;
            }, {}),
            'subparameters_used': subparameters_used
          }
          let config = {'configuration': moduleConfig, ...moduleExecution, 'active': moduleActive===true ? 1 : 0}
          config_data(config)
        }
      }, [moduleDraftSaveConfiguration, moduleActive, moduleExecution, parameters, subparameters, criteria])
      const handleUpdateConfig = async () => {
        try {
          let config = {'configuration': {
            'conversation_potential': {
              'overall': {
                'logic': manualQuery,
                'logic_explanation': logicExplanationConvoPotential,
                'output_type': 'Categorical',
                'display_name': 'Conversation Potential',
                'possible_values': possibleValues,
              },
              'subparameters_used': subparameters_used,
              'subparameters': subparameters
            },
            'customer_potential': {
              'overall': {
                'logic': manualQueryQuery,
                'logic_explanation': logicExplanationCustomerPotential,
                'output_type': 'Categorical',
                'display_name': 'Customer Potential',
                'possible_values': possibleValuesQuery
              },
            }
          }, ...moduleExecution, 'active': moduleActive===true ? 1 : 0}
          let res = await server.postModuleDraftSaveConfiguration({client_id, service_id, email, module_name: 'lead_quality', 'configuration': config, 'menu': 'apps', 'submenu': undefined})
          if(res.status === 200) {
            showToast(await getApiToastMessage(res, 'Draft saved successfully'), "success")
          } else {
            showToast(await getApiToastMessage(res, 'Failed to save draft'), "error")
          }
        } catch (error) {
          showToast('Failed to save draft', "error")
        }finally{
          setLoading(false)
        }
      }
  
  const getLoadedConfigForDiff = () => (
    configType === 'Default'
      ? (agentFeedbackModule || defaultConfig?.configuration || {})
      : (
        moduleDraftSaveConfiguration?.configuration?.configuration ||
        moduleDraftSaveConfiguration?.configuration ||
        agentFeedbackModule ||
        {}
      )
  );

  const getCurrentConfigForDiff = () => ({
    conversation_potential: {
      overall: {
        logic: manualQuery,
        logic_explanation: logicExplanationConvoPotential,
        output_type: 'Categorical',
        display_name: 'Conversation Potential',
        possible_values: possibleValues,
      },
      subparameters: subparameters.reduce((acc, subparam) => {
        acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
          output_type: subparam.output_type || 'Yes/No',
          system: subparam.system || 0,
          instruction: subparam.instruction || '',
          ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation', ...callTypeSettings(subparam) } : {}),
          ...classifierSettings(subparam),
          display_name: subparam.display_name,
          possible_values: subparam.possible_values,
        };
        return acc;
      }, {}),
      subparameters_used,
    },
    customer_potential: {
      overall: {
        logic: manualQueryQuery,
        logic_explanation: logicExplanationCustomerPotential,
        output_type: 'Categorical',
        display_name: 'Customer Potential',
        possible_values: possibleValuesQuery,
      },
      subparameters: customerPotentialSubparameters.reduce((acc, subparam) => {
        acc[subparam.display_name.toLowerCase().replace(/[\s-\/\&]+/g, '_')] = {
          output_type: subparam.output_type || 'Yes/No',
          system: subparam.system || 0,
          instruction: subparam.instruction || '',
          ...(!subparam.logic ? { context_scope: subparam.context_scope || 'conversation' } : {}),
          ...classifierSettings(subparam),
          display_name: subparam.display_name,
          possible_values: subparam.possible_values,
        };
        return acc;
      }, {}),
    },
  });

  // Configuration Screen
  if (!showPreview) {
    return (
      <div className="p-3 h-full min-h-0 overflow-hidden">
        <div className="mx-auto flex h-full min-h-0 flex-col">
          <div className="flex flex-wrap items-center justify-between gap-3 mb-4 shrink-0">
            <div>
              <h1 className="text-xl font-semibold text-gray-900 mb-2 flex items-center">Lead Quality <span className='inline-flex items-center px-2 py-1 rounded-full whitespace-nowrap font-normal text-xs bg-gray-200 ml-1' style={{color: "gray"}}>{configType.replace(/^Reset to /, '')}</span></h1>
              <p className="text-gray-500 text-sm mt-1">Configure and customize lead quality parameters</p>
              
              {/* Configuration Import/Export Buttons */}
             {role === 'superadmin' && <div className="flex items-center gap-2 mt-3">
                <label className="cursor-pointer">
                  <input
                    type="file"
                    accept=".json"
                    onChange={handleUploadConfig}
                    className="hidden"
                    id="config-upload"
                  />
                  <button
                    type="button"
                    className="px-3 py-1.5 bg-blue-100 text-blue-700 rounded-lg border border-blue-300 hover:bg-blue-200 flex items-center text-sm"
                    onClick={() => document.getElementById('config-upload').click()}
                  >
                    <Upload className="w-4 h-4 mr-1" />
                    Upload Config
                  </button>
                </label>
                
                <button
                  type="button"
                  className="px-3 py-1.5 bg-green-100 text-green-700 rounded-lg border border-green-300 hover:bg-green-200 flex items-center text-sm"
                  onClick={handleDownloadConfig}
                >
                  <Download className="w-4 h-4 mr-1" />
                  Download Config
                </button>
              </div>}
            </div>
            <div className="flex flex-wrap items-center gap-y-2">
            <div className="relative inline-block w-12 mr-2 align-middle select-none">
                  <input class="global-input"
                    type="checkbox" 
                    checked={moduleActive} 
                    onChange={(e) => setModuleActive(moduleActive===true ? false : true)}
                    className="sr-only"
                    id="toggle-all"
                  />
                  <label 
                    htmlFor="toggle-all"
                    className={`block h-5 rounded-full cursor-pointer transition-colors duration-200 ease-in-out ${moduleActive===true ? 'bg-indigo-600' : 'bg-gray-200'}`}
                  >
                    <span 
                      className={`block h-5 w-5 bg-white rounded-full shadow transform duration-200 ease-in-out ${moduleActive===true ? 'translate-x-7' : 'translate-x-0'}`}
                    />
                  </label>
                </div>
                <button 
                  className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-200 mr-2 flex items-center"
                  onClick={handleUpdateConfig}
                >
                  <Save className="w-4 h-4 mr-2" />
                  Save as Draft
                </button>
                <ConfigurationDiffButton
                  title="Lead Quality Changes"
                  originalConfig={() => configWithExecutionSettings(getLoadedConfigForDiff(), loadedModuleExecution)}
                  modifiedConfig={() => configWithExecutionSettings(getCurrentConfigForDiff(), moduleExecution)}
                />
                {showSampleTest && <button 
                className="px-4 py-2 bg-gray-100 text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-200"
                onClick={() => setShowSampleTestModal(true)}
              >
                Manage Test Set
              </button>}
                <div className="relative inline-block mx-2">
                  <button
                    className="flex items-center px-4 py-2 bg-gray-100 text-gray-700 rounded-lg border border-gray-300 hover:bg-gray-200"
                    onClick={() => setShowConfigDropdown((prev) => !prev)} style={{width: "10rem", justifyContent: "space-between"}}
                    type="button"
                  >
                    {configType}
                    <span className="ml-2">
                      {showConfigDropdown ? (
                        // Up arrow
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                        </svg>
                      ) : (
                        // Down arrow
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      )}
                    </span>
                  </button>
                  {showConfigDropdown && (
                    <div className="absolute z-10 mt-2 w-44 bg-white border border-gray-200 rounded-lg shadow-lg">
                      {['Live Version', 'Saved Draft', 'Default'].map(option => (
                        <div
                          key={option}
                          className={`px-4 py-2 cursor-pointer hover:bg-gray-100 text-sm ${configType === option ? 'text-indigo-600' : ''}`}
                          onClick={() => {
                            setConfigType(option);
                            setShowConfigDropdown(false);
                          }}
                        >
                          {option}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
            <button disabled={!isValid || queryError || manualQuery==='' || !isValidQuery || queryErrorQuery || manualQueryQuery==='' || descriptionError}
              className={`px-4 py-2 ${!isValid || queryError || manualQuery==='' || !isValidQuery || queryErrorQuery || manualQueryQuery==='' ? 'bg-gray-500 hover:bg-gray-700' : 'bg-indigo-600 hover:bg-indigo-700'} text-white rounded  focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2`}
              onClick={() => {setShowPreview(true); generateSamples(1);}}
            >
              Preview
            </button>
            </div>
          </div>
          

          <div className="flex flex-wrap items-center gap-x-6 gap-y-2 mb-4 shrink-0">
            <div className="flex items-center gap-2 text-sm font-medium text-gray-700">
              Also run analytics for
              <span className="relative group">
                <button type="button" aria-label="About call-type settings" className="flex text-gray-500 hover:text-gray-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded">
                  <Info size={16} />
                </button>
                <span role="tooltip" className="absolute left-0 top-full z-50 mt-2 hidden w-64 rounded bg-gray-800 px-3 py-2 text-xs font-normal text-white shadow-lg group-hover:block group-focus-within:block">
                  Proper conversations run by default when the module is active. For other conversation types, enable the module option and each required parameter separately.
                </span>
              </span>
            </div>
            <div className="flex flex-wrap items-center gap-x-6 gap-y-2">
              {callTypeOptions.map(([key, label]) => (
                <label key={key} className="flex items-center gap-2 text-sm text-gray-700">
                  <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500"
                    checked={moduleExecution[key] === 1}
                    onChange={e => setModuleExecution(prev => ({...prev, [key]: e.target.checked ? 1 : 0}))} />
                  {label}
                </label>
              ))}
            </div>
          </div>

          {!loading && <div className="bg-white rounded-lg shadow min-h-0 flex-1 overflow-y-auto">
            <div className="sticky top-0 z-10 bg-white border-b border-gray-200">
              <nav className="flex overflow-x-auto whitespace-nowrap" aria-label="Tabs">
              <button
                  onClick={() => {setActiveTab('conversationPotential');setError('')}}
                  className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                    activeTab === 'conversationPotential'
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Conversation Potential
                </button>
                <button
                  onClick={() => {setActiveTab('customerPotential'); setError('');}}
                  className={`py-4 px-6 text-center border-b-2 font-medium text-sm ${
                    activeTab === 'customerPotential'
                      ? 'border-indigo-500 text-indigo-600'
                      : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                  }`}
                >
                  Customer Potential
                </button>
              </nav>
            </div>

            {activeTab === 'conversationPotential' && (
              <div className="p-4">
                <div className="mb-4">
                 <div className='p-4 border-b border-gray-200 shadow-md rounded-lg'>
                 <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Possible Values
                    </label>
                    <div className="flex gap-2 mb-2">
                      <input
                        type="text"
                        className="flex-1 px-3 py-2 border border-gray-300 rounded-md global-input"
                        value={possibleValue}
                        onChange={(e) => setPossibleValue(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleAddPossibleValue()}
                        placeholder="Type and press Enter to add"
                      />
                      <button
                        onClick={handleAddPossibleValue}
                        className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
                      >
                        Add
                      </button>
                    </div>
                    <div className="flex flex-wrap gap-2 mt-2">
                      {possibleValues && possibleValues.map((tag, index) => (
                        <div key={index} className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded-full">
                          <span className="text-sm text-gray-700">{tag}</span>
                          <button
                            onClick={() => handleRemovePossibleValue(tag)}
                            className="text-gray-500 hover:text-gray-700"
                          >
                            <FaTimes style={{color: "slategray"}}/>
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                  <div className="mb-6">
                    <div className="flex justify-between items-end mb-2">
                      <div className="flex items-center gap-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Logic
                        </label>
                        <div className="relative">
                          <Info 
                            size={16} 
                            className="text-gray-400 hover:text-gray-600 cursor-pointer"
                            onClick={() => setShowLogicInfo(!showLogicInfo)}
                          />
                          {showLogicInfo && (
                            <div className="absolute z-50 left-6 -top-2 w-[700px] h-[40vh] overflow-auto bg-white border border-gray-200 rounded-lg shadow-lg p-4">
                              <div className="flex flex-col gap-2">
                                <div className="flex justify-between items-center">
                                <h4 className="font-medium text-gray-800">Write Scoring Logic (Python-style)</h4>
                                <button
                                  onClick={() => setShowLogicInfo(false)}
                                  className="text-gray-500 hover:text-gray-700"
                                >
                                  <FaTimes style={{color: "slategray"}}/>
                                </button>
                                </div>
                                <p className="text-sm text-gray-600">Use simple if, elif, and else statements to define logic.</p>
                                <ul className="text-sm text-gray-600 list-disc pl-4 space-y-1">
                                  <li>Only use subparameters you have added, with the same spelling.</li>
                                  <li>Return numeric values only (between 0 and 100).</li>
                                  <li>Supports and, or, in, not in, math expressions, and nesting.</li>
                                </ul>
                                <div className="mt-2">
                                  <p className="text-sm font-medium text-gray-700 mb-1">Examples:</p>
                                  <pre className="bg-gray-50 p-2 rounded text-sm">
                                    {`Example 1 - 
      if greeting == "Yes" and brand_name_mention == "Yes":
          return 100
      else:
          return 0

      Example 2 -
      if customer_sentiment == "Very Positive":
          return 100
      elif customer_sentiment == "Positive":
          return 80
      elif greeting == "Yes" and brand_name_mention == "Yes":
          return 60
      else:
          return 0

      Example 3 - 
      if (1==1):
          return (0.5 * agent_engagement_score + 0.5 * customer_satisfaction_score)`}
                                  </pre>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={() => verifyQuery()}
                        className="px-4 py-1 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 border border-gray-300" style={{height: "40px", borderRadius: "4px"}}
                      >
                        Validate Logic
                      </button>
                    </div>
                    <div className='p-3 border rounded-lg my-2 mb-4 bg-indigo-50 border-indigo-200'>
              <div>
                <div className='flex items-center justify-between h-6 cursor-pointer' onClick={() => setWriteWithAiEnabledConvoPotential(!writeWithAiEnabledConvoPotential)}>
                <div className="text-sm font-medium flex items-center text-indigo-600">
                 <Sparkles className='h-4 w-4 mr-2 text-indigo-600'/> Write with AI
                </div>
                <div className='flex items-center gap-2 cursor-pointer'>
                {writeWithAiEnabledConvoPotential ? (
                  // Up arrow when open
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                ) : (
                  // Down arrow when closed
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                )}
                </div>
                </div>
              {writeWithAiEnabledConvoPotential && <div className='mt-2'>
                <div>
                  <textarea
                    className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none global-input"
                    rows="6"
                    placeholder="Describe the logic you want to implement using the subparameters above…"
                    value={promptQueryConvoPotential}
                    onChange={(e) => setPromptQueryConvoPotential(e.target.value)} style={{fontSize: "14px"}}
                  />
                </div>
                <div className='flex justify-end'>
                  <button
                    onClick={generateLogicWithAIConvoPotential}
                    className="px-4 py-1 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center text-sm" style={{height: "35px", borderRadius: "4px"}}
                  >
                    <Wand2 className='h-3 w-3 mr-2'/> Generate
                  </button>
                </div>
                </div>}
              </div>
            </div>
                    {/* <p style={{fontSize: "12px", fontStyle: "italic", color: "gray"}}>Score should be between 0 to 100</p> */}
                    {!logicLoading && (
                      <>
                      <div className='flex items-center gap-2 mt-2'>
                        <p style={{fontSize: "12px", fontStyle: "italic", color: "gray",width: "60%"}}></p>
                        <p style={{fontSize: "12px", fontStyle: "italic", color: "gray",width: "40%"}}>Explanation</p>
                      </div>
                    <div className='flex items-start gap-2 mb-6'>
                      <textarea
                        className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none global-input"
                        rows="6"
                        placeholder="Enter your logic here..."
                        value={manualQuery}
                        onChange={(e) => handleQueryChange(e.target.value)} 
                        style={{border: queryError ? "1px solid red" : "", width: "60%", height: "200px", overflow: "auto", fontSize: "14px"}}
                      />
                      <textarea
                        className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none global-input"
                        rows="6"
                        value={logicExplanationConvoPotential}
                        onChange={(e) => setLogicExplanationConvoPotential(e.target.value)} 
                        style={{ width: "40%", height: "200px", overflow: "auto", fontSize: "14px", whiteSpace: "pre-line"}}
                      />
                    </div>
                    </>
                  )}
                    {
                      logicLoading && (
                        <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                          <div className="loader"></div>
                          <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                        </div>
                      )
                    }
                    {queryError && (
                      <p className="mt-2 text-sm text-red-600">{queryError}</p>
                    )}
                  </div>
                  <div className="flex flex-wrap items-center gap-4 my-3">
                    <div className="flex-1 min-w-[12rem]"><ConfigurationTableSearch className="" label="Search conversation subparameters by name" value={tableSearch.conversation} onChange={value => setTableSearch({ ...tableSearch, conversation: value })} /></div>
                    <button
                      className="px-4 py-1 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 mr-2" style={{height: "40px", borderRadius: "4px"}}
                      onClick={handleAddSubparameter}
                    >
                      Add Subparameter
                    </button>
                  </div>
                  <div className="overflow-x-auto">
                    <table className="configuration-table divide-y divide-gray-200">
                      <colgroup>
                        <col style={{ width: "18%" }} />
                        <col style={{ width: "28%" }} />
                        <col style={{ width: "16%" }} />
                        <col />
                        <col style={{ width: "110px" }} />
                      </colgroup>
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Definition</th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Options</th>
                          <th scope="col" className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {parameterTableRows(subparameters, tableSearch.conversation).map(param => (
                          <tr key={param.id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{param.display_name}</td>
                            <td className="px-6 py-4 text-sm text-gray-500 max-w-xs truncate">{param.instruction}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{param.output_type}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-wrap">{param.output_type !== 'Number' ? <ConfigurationOptions options={param.possible_values} /> : '-'}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                              {param.system ? (
                                <span className="text-gray-400">{param.system === 2 ? 'Client System Parameter' : 'System Parameter'}</span>
                              ) : (
                                <>
                                  <button 
                                    className="text-indigo-600 hover:text-indigo-900 mr-4 text-md"
                                    onClick={() => handleEditSubparameter(param.id)}
                                  >
                                    <FaRegEdit/>
                                  </button>
                                </>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                 </div>
                  {showSubparameterModal && (
  <div id="editing-parameter" className="flex items-center justify-center" style={{width: "85%", margin: "auto", marginTop: "2rem"}}>
    <div className="bg-white rounded-lg w-full" style={{border: "1px solid rgb(229 231 235"}}>
      <div className="flex justify-between items-center p-4 border-b">
        <h2 className="text-xl font-semibold text-gray-800 flex items-center">
          {editingParameter?.id ? "Edit Subparameter" : "Add Subparameter"}
          {editingParameter && editingParameter.id && <div className="ml-1 relative">
            <div className="group">
              <Info className="h-4 w-4 text-gray-500 cursor-help ml-2" />
              <div className="absolute left-0 top-full mt-1 w-64 bg-white border border-gray-200 shadow-sm text-gray-700 text-xs rounded py-2 px-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-10 pointer-events-none">
                Name & Output type can't be modified.
              </div>
            </div>
          </div>}
        </h2>
        <button 
          onClick={() => {setSubparameterName('');
            setSubparameterDefinition('');
            setContextScope('conversation');
            setParameterExecution({});
            setSubparameterType('Yes/No/NA');
            setSubparameterPossibleValues([]);
            setSubparameterTags([]);
            setEditingParameter(null);
            setShowSubparameterModal(false);}}
          className="text-gray-500 hover:text-gray-700"
        >
          <FaTimes style={{color: "slategray"}}/>
        </button>
      </div>

      {!showLoadConfigurePart && <div className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Name
          </label>
          <input
            type="text"
            className="w-full px-3 py-2 border border-gray-300 rounded-md global-input"
            value={subparameterName}
            onChange={(e) => handleChangeParams(e, 'subparameter')} disabled={editingParameter?.id}
          />
          <div style={{display: "flex", justifyContent: "left", color: "red", fontSize: "12px"}}>{error}</div>
        </div>

        <ClassifierFields value={{ ...classification, output_type: subparameterType, possible_values: subparameterPossibleValues, instruction: subparameterDefinition }} onChange={setClassification} />
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Context
          </label>
          <ModernTimeDropdown
            width="w-full"
            ariaLabel="Context"
            value={contextScope === 'customer' ? 'Customer context' : 'Conversation context (default)'}
            options={['Conversation context (default)', 'Customer context']}
            onChange={(e) => setContextScope(e.target.value === 'Customer context' ? 'customer' : 'conversation')}
          />
          <p className="mt-1 text-xs text-gray-500">
            {contextScope === 'customer'
              ? 'Uses up to 50 recent conversations, including this call and non-connected calls.'
              : 'Uses this conversation only.'}
          </p>
          <div className="mt-3">
            <p className="text-sm font-medium text-gray-700 mb-2">Run this parameter for</p>
            <div className="flex flex-wrap gap-4">
              {callTypeOptions.map(([key, label]) => (
                <label key={key} className="flex items-center gap-2 text-sm text-gray-700">
                  <input type="checkbox" className="rounded text-indigo-600 focus:ring-indigo-500"
                    disabled={moduleExecution[key] !== 1}
                    checked={moduleExecution[key] === 1 && parameterExecution[key] === 1}
                    onChange={e => setParameterExecution(prev => ({...prev, [key]: e.target.checked ? 1 : 0}))} />
                  {label}
                </label>
              ))}
            </div>
            <p className="mt-1 text-xs text-gray-500">Enable the module call type, then opt this parameter in. Disabled parameters return None; existing calculation rules still apply.</p>
          </div>

        </div>
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Definition
          </label>
          <textarea
            className="w-full px-3 py-2 border border-gray-300 rounded-md global-input"
            rows="3"
            value={subparameterDefinition}
            onChange={(e) => setSubparameterDefinition(e.target.value)}
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Type
          </label>
          <ModernTimeDropdown width='w-full' isDisabled={editingParameter?.id} placeholder="Select Type" value={subparameterType === 'Date and Time' ? 'Date and Time (ISO Format - YYYY-MM-DDTHH:MM:SS)' : subparameterType} options={classifierOutputOptions(classification.subparameter_type, ['Yes/No/NA', 'Categorical', 'Number', 'Text', 'Date and Time (ISO Format - YYYY-MM-DDTHH:MM:SS)'])}
            onChange={(e) => {
              const label = 'Date and Time (ISO Format - YYYY-MM-DDTHH:MM:SS)';
              setSubparameterType(e.target.value === label ? 'Date and Time' : e.target.value)
            }} />
        </div>

        {subparameterType === 'Categorical' && (
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Options
            </label>
            <div className="flex gap-2 mb-2">
              <input
                type="text"
                className="flex-1 px-3 py-2 border border-gray-300 rounded-md global-input"
                value={currentTag}
                onChange={(e) => setCurrentTag(e.target.value)}
                onKeyPress={(e) => e.key === 'Enter' && handleAddTag()}
                placeholder="Type and press Enter to add"
              />
              <button
                onClick={handleAddTag}
                className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700"
              >
                Add
              </button>
            </div>
            <div className="flex flex-wrap gap-2 mt-2">
              {subparameterPossibleValues.map((tag, index) => (
                <div key={index} className="flex items-center gap-1 bg-gray-100 px-3 py-1 rounded-full">
                  <span className="text-sm text-gray-700">{tag}</span>
                  <button
                    onClick={() => handleRemoveTag(tag)}
                    className="text-gray-500 hover:text-gray-700"
                  >
                    <FaTimes style={{color: "slategray"}}/>
                  </button>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>}
      {
        showLoadConfigurePart && (
          <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
            <div className="loader"></div>
            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
          </div>
        )
      }

      <div className="p-4 border-t flex justify-end space-x-3">
        <button
          onClick={() => {setSubparameterName('');
            setSubparameterDefinition('');
            setContextScope('conversation');
            setParameterExecution({});
            setSubparameterType('Yes/No/NA');
            setSubparameterPossibleValues([]);
            setSubparameterTags([]);
            setEditingParameter(null);
            setShowSubparameterModal(false);}}
          className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50" style={{height: "40px", borderRadius: "4px"}}
        >
          Cancel
        </button>
        <button
          onClick={handleSaveSubparameter}
          className="px-4 py-2 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed" style={{height: "40px", borderRadius: "4px"}}
          disabled={showLoadConfigurePart}
        >
          Save
        </button>
      </div>
    </div>
  </div>
)}
                </div>
              </div>
            )}

            {activeTab === 'customerPotential' && (
              <div className="p-4">
                <div className='p-4 border-b border-gray-200 shadow-md rounded-lg mb-4'>
                  <div className="mb-6">
                    <div className="flex justify-between items-end mb-2">
                      <div className="flex items-center gap-2">
                        <label className="block text-sm font-medium text-gray-700">
                          Logic
                        </label>
                        <div className="relative">
                          <Info 
                            size={16} 
                            className="text-gray-400 hover:text-gray-600 cursor-pointer"
                            onClick={() => setShowLogicInfo(!showLogicInfo)}
                          />
                          {showLogicInfo && (
                            <div className="absolute z-50 left-6 -top-2 w-[700px] h-[40vh] overflow-auto bg-white border border-gray-200 rounded-lg shadow-lg p-4">
                              <div className="flex flex-col gap-2">
                                <div className="flex justify-between items-center">
                                <h4 className="font-medium text-gray-800">Write Scoring Logic (Python-style)</h4>
                                <button
                                  onClick={() => setShowLogicInfo(false)}
                                  className="text-gray-500 hover:text-gray-700"
                                >
                                  <FaTimes style={{color: "slategray"}}/>
                                </button>
                                </div>
                                <p className="text-sm text-gray-600">Use simple if, elif, and else statements to define logic.</p>
                                <ul className="text-sm text-gray-600 list-disc pl-4 space-y-1">
                                  <li>Only use subparameters you have added, with the same spelling.</li>
                                  <li>Return numeric values only (between 0 and 100).</li>
                                  <li>Supports and, or, in, not in, math expressions, and nesting.</li>
                                </ul>
                                <div className="mt-2">
                                  <p className="text-sm font-medium text-gray-700 mb-1">Examples:</p>
                                  <pre className="bg-gray-50 p-2 rounded text-sm">
                                    {`Example 1 - 
      if greeting == "Yes" and brand_name_mention == "Yes":
          return 100
      else:
          return 0

      Example 2 -
      if customer_sentiment == "Very Positive":
          return 100
      elif customer_sentiment == "Positive":
          return 80
      elif greeting == "Yes" and brand_name_mention == "Yes":
          return 60
      else:
          return 0

      Example 3 - 
      if (1==1):
          return (0.5 * agent_engagement_score + 0.5 * customer_satisfaction_score)`}
                                  </pre>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                      <button
                        onClick={() => verifyQueryQuery()}
                        className="px-4 py-1 bg-gray-100 text-gray-700 rounded-lg hover:bg-gray-200 border border-gray-300" style={{height: "40px", borderRadius: "4px"}}
                      >
                        Validate Logic
                      </button>
                    </div>
                    <div className='p-3 border rounded-lg my-2 mb-4 bg-indigo-50 border-indigo-200'>
              <div>
                <div className='flex items-center justify-between h-6 cursor-pointer' onClick={() => setWriteWithAiEnabledCustomerPotential(!writeWithAiEnabledCustomerPotential)}>
                <div className="text-sm font-medium flex items-center text-indigo-600">
                 <Sparkles className='h-4 w-4 mr-2 text-indigo-600'/> Write with AI
                </div>
                <div className='flex items-center gap-2 cursor-pointer'>
                {writeWithAiEnabledCustomerPotential ? (
                  // Up arrow when open
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 15l7-7 7 7" />
                  </svg>
                ) : (
                  // Down arrow when closed
                  <svg
                    className="w-4 h-4 text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                  </svg>
                )}
                </div>
                </div>
              {writeWithAiEnabledCustomerPotential && <div className='mt-2'>
                <div>
                  <textarea
                    className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none global-input"
                    rows="6"
                    placeholder="Describe the logic you want to implement using the subparameters above…"
                    value={promptQueryCustomerPotential}
                    onChange={(e) => setPromptQueryCustomerPotential(e.target.value)} style={{fontSize: "14px"}}
                  />
                </div>
                <div className='flex justify-end'>
                  <button
                    onClick={generateLogicWithAICustomerPotential}
                    className="px-4 py-1 bg-indigo-600 text-white rounded-lg hover:bg-indigo-700 flex items-center text-sm" style={{height: "35px", borderRadius: "4px"}}
                  >
                    <Wand2 className='h-3 w-3 mr-2'/> Generate
                  </button>
                </div>
                </div>}
              </div>
            </div>
                    {/* <p style={{fontSize: "12px", fontStyle: "italic", color: "gray"}}>Score should be between 0 to 100</p> */}
                    {!logicLoading && (
                      <>
                      <div className='flex items-center gap-2 mt-2'>
                        <p style={{fontSize: "12px", fontStyle: "italic", color: "gray",width: "60%"}}></p>
                        <p style={{fontSize: "12px", fontStyle: "italic", color: "gray",width: "40%"}}>Explanation</p>
                      </div>
                      <div className='flex items-start gap-2 mb-6'>
                        <textarea
                          className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none global-input"
                          rows="6"
                          placeholder="Enter your logic here..."
                          value={manualQueryQuery}
                          onChange={(e) => handleQueryChangeQuery(e.target.value)} 
                          style={{border: queryErrorQuery ? "1px solid red" : "", width: "60%", height: "200px", overflow: "auto", fontSize: "14px"}}
                        />
                        <textarea
                          className="w-full px-3 py-2 text-gray-700 border rounded-lg focus:outline-none global-input"
                          rows="6"
                          value={logicExplanationCustomerPotential}
                          onChange={(e) => setLogicExplanationCustomerPotential(e.target.value)} 
                          style={{ width: "40%", height: "200px", overflow: "auto", fontSize: "14px", whiteSpace: "pre-line"}}
                        />
                      </div>
                      </>
                  )}
                    {
                      logicLoading && (
                        <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                          <div className="loader"></div>
                          <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                        </div>
                      )
                    }
                    {queryErrorQuery && (
                      <p className="mt-2 text-sm text-red-600">{queryErrorQuery}</p>
                    )}
                  </div>
                  </div>
                <div className="overflow-x-auto mt-12">
                    <ConfigurationTableSearch className="mb-3" label="Search customer subparameters by name" value={tableSearch.customer} onChange={value => setTableSearch({ ...tableSearch, customer: value })} />
                    <table className="configuration-table divide-y divide-gray-200">
                      <colgroup>
                        <col style={{ width: "20%" }} />
                        <col style={{ width: "35%" }} />
                        <col style={{ width: "16%" }} />
                        <col />
                      </colgroup>
                      <thead className="bg-gray-50">
                        <tr>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Definition</th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Type</th>
                          <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Options</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {parameterTableRows(customerPotentialSubparameters, tableSearch.customer).map(param => (
                          <tr key={param.id}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{param.display_name}</td>
                            <td className="px-6 py-4 text-sm text-gray-500 max-w-xs">{param.instruction}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{param.output_type}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500 text-wrap">{param.output_type !== 'Number' ? <ConfigurationOptions options={param.possible_values} /> : '-'}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
              </div>
            )}
          </div>}
          {
            loading && (
              <div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
                <div className="loader"></div>
                <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
              </div>
            )
          }
        </div>
        {
          showSampleTestModal && (
            <div>
              <div style={{position: "fixed", left: "2%", top: "6.5%", width: "96%", height: "90%", background: "white", borderRadius: "10px", boxShadow: "rgba(0, 0, 0, 0.05) 0px 1px 3px", 
                zIndex: "999999999", padding: "0 15px"}}>
                <SampleTestModal clientID={client_id} serviceID={service_id} emailID={email} moduleName='lead_quality' onClose={handleCloseSampleTestModal}/>
              </div>
            </div>
          )
        }
      </div>
    );
  }
  
  // Preview Screen
  return (
    <div className="p-3">
      <div className=" mx-auto">
        <div className="flex items-center justify-between mb-6">
          <div>
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Lead Quality</h1>
            <p className="text-gray-500 text-sm mt-1">Sample results (Only for Conversation Potential)</p>
          </div>
          <div className="flex space-x-3">
            <button 
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded hover:bg-gray-50 focus:outline-none"style={{height: "40px", borderRadius: "4px"}}
              onClick={() => {setShowPreview(false); setExpandedSample(null); setSamples([]);}}
            >
              Go Back
            </button>
            <button onClick={() => {generateSamples(0); setSamples([]); setExpandedSample(null);}} className="px-4 py-2 bg-gray-100 text-gray-700 border border-gray-300 rounded hover:bg-gray-200 focus:outline-none"style={{height: "40px", borderRadius: "4px"}}>
              Run Different Sample
            </button>
            <ConfigurationDiffButton
              title="Lead Quality Changes"
              originalConfig={() => configWithExecutionSettings(getLoadedConfigForDiff(), loadedModuleExecution)}
              modifiedConfig={() => configWithExecutionSettings(getCurrentConfigForDiff(), moduleExecution)}
              triggerLabel="Deploy"
              showTriggerIcon={false}
              disabled={loading}
              triggerClassName={`px-4 py-1 h-10 ${loading ? 'bg-gray-500 hover:bg-gray-600' : 'bg-indigo-600 hover:bg-indigo-700'}  text-white rounded  focus:outline-none`}
              onNext={() => setShowDeployConfirmation(true)}
            />
          </div>
        </div>
        <DeployConfirmationModal
          isOpen={showDeployConfirmation}
          confirmationText={`Changes will be deployed in ${client_id || 'N/A'}, ${service_id || 'N/A'} and ${module_name || 'lead_quality'}`}
          onClose={() => setShowDeployConfirmation(false)}
          onConfirm={(versionDescription) => {
            setShowDeployConfirmation(false);
            deployModule(versionDescription);
          }}
        />

        <div style={{height: "75vh", overflow: "auto"}}>
        {!loading && Array.isArray(samples) && samples.map((sample, index) => (
          <div key={sample.call_id} className="border-b border-gray-200 last:border-0 my-2">
            <div  onClick={() => setExpandedSample(expandedSample === index ? null : index)} className='p-4 border-b rounded-lg border-gray-200 bg-gray-50 cursor-pointer'>
            <div 
              className="flex justify-between items-center"
             
            >
              <div className="flex items-center">
                <span className="font-medium text-gray-800">{sample.name}</span>
              </div>
              <svg 
                className={`w-5 h-5 text-gray-500 transform transition-transform ${expandedSample === index ? 'rotate-180' : ''}`} 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24" 
                xmlns="http://www.w3.org/2000/svg"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
            <div className="text-sm text-gray-600 mt-1 capitalize" style={{fontSize: "12px"}}>
                        Call ID: {sample.call_id} | Time: {sample.call_time} | Employee: {sample.employee_name} | Record Type: {sample.record_type}
                      </div>
            </div>
            {expandedSample === index && (
              <div className="bg-white rounded-lg shadow p-4 overflow-hidden border flex">
                <div className="border border-gray-200 rounded-lg overflow-hidden" style={{flex: "0.65"}}>
                            <div 
                              className="p-2 bg-gray-50 border-b border-gray-200 cursor-pointer flex items-center" style={{justifyContent: "space-between"}}
                            >
                              
                              <div className="flex items-center">
                                <svg className="w-5 h-5 text-gray-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7v8a2 2 0 002 2h6M8 7V5a2 2 0 012-2h4.586a1 1 0 01.707.293l4.414 4.414a1 1 0 01.293.707V15a2 2 0 01-2 2h-2M8 7H6a2 2 0 00-2 2v10a2 2 0 002 2h8a2 2 0 002-2v-2"></path>
                                </svg>
                                <h3 className="font-medium text-gray-800">Output</h3>
                              </div>

                            </div>
                            <div className="p-4">
                  {sample.parameters && <FeedbackSection key="parameters" showMoreMap={showMoreMap} toggleShowMore={toggleShowMore} source_click={(source)=>handleSourceClick(source, sample.segments)}
                  dataKey="Lead Quality" data={sample.parameters} maxHeight="45vh" />}
                </div>
                </div>
                {/* Audio Section */}
                <div className="ml-2 border border-gray-200 rounded-lg overflow-hidden" style={{flex: "0.35"}}>
                            <div className="p-2 bg-gray-50 border-b border-gray-200 flex items-center">
                              <div className="flex items-center">
                              {sample.record_type === 'call' ? (
                  <svg className="w-5 h-5 text-gray-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z"></path>
                </svg>
                  ) : (<IoChatbubbleOutline style={{marginRight: "0.5rem", height: "30px"}}/>)}
                                <h3 className="font-medium text-gray-800">{sample.record_type === 'call' ? 'Audio' : 'Chat' }</h3>
                              </div>
                            </div>
                            {sample.record_link && <div className="p-2 bg-white">
                              <audio controls key={sample.record_link} ref={audioRef} onTimeUpdate={()=>handleAudioTimeUpdate(sample.segments)} style={{ width: "96%", margin: "0 1rem", height: "40px" }}>
                                <source src={sample.record_link} type="audio/mpeg" />
                                Your browser does not support the audio element.
                              </audio>
                            </div>}
                            <hr/>
                            <div style={{fontSize: "13px", margin: "10px", overflow: 'auto', minHeight: "30vh", maxHeight: "40vh"}}>
                            {
                              sample.record_type === 'call' && sample.segments.map((item, idx)=> {
                                        const isSelected = selectedSegmentIdx === idx;
                                        return (
                                          <div key={`segment_${idx}`} ref={(el) => (segmentRefs.current[idx] = el)} onClick={()=>toggleSegment(item, idx, sample.record_link)} style={{marginBottom: "10px", borderLeft: isSelected ? "4px solid #6f6ffe":"", background: isSelected ? "rgba(249, 250, 251, 1)":"",
                                            padding: "2px 5px", minHeight: "50px", display: "flex", flexDirection: "column", justifyContent: "space-between", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", cursor: "pointer"}}>
                                            <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                              <div style={{fontSize: "14px", color: "grey"}}>{item.speaker}</div>
                                              <div style={{fontSize: "14px", color: "grey"}}>{formatTime(item.start_time)}</div>
                                            </div>
                                            <div style={{fontSize: "15px"}}>{item.text}</div>
                                          </div>
                                        )
                                      })
                                    }
                            {
                              sample.record_type === 'chat' && sample.segments.map((item, idx)=> {
                                return (
                                  <div key={`segment_${idx}`}
                                  data-message-id={item.message_id}
                                  style={{marginBottom: "10px", borderLeft: getBorderColor(item.actor_type), background: getBackgroundColor(item.actor_type),
                                    padding: "2px 5px", minHeight: "50px", display: "flex", flexDirection: "column", justifyContent: "space-between", boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)", cursor: "pointer"}}>
                                    <div style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                                      <div style={{fontSize: "10px", display: "flex", alignItems: "center"}}>
                                        <span className='' style={{padding: "2px 8px", borderRadius: "10px", border: "1px solid rgba(0, 0, 0, 0.26)"}}>{item.actor_type}</span>
                                        {item.message_type !== 'normal' && <span className=' ml-1' style={{padding: "2px 8px", borderRadius: "10px", border: "1px solid rgba(0, 0, 0, 0.26)"}}>{item.message_type}</span>}
                                      </div>
                                      <div style={{fontSize: "13px", color: "grey"}}>{formatEpochTime(item.timestamp)}</div>
                                    </div>
                                    <div style={{fontSize: "14px"}}><span style={{whiteSpace: "pre-line"}}>{item.content?.text?.content} <br/></span></div>
                                    {item.content.image && item.content.image.url && 
                                      <div style={{fontSize: "15px", whiteSpace: "pre-line"}}>
                                        <br/>
                                       Image Shared - {item.content.image.url}
                                      </div>
                                      }
                                    {
                                      item.content.buttons && item.content.buttons.length > 0 && (
                                        <div>
                                          <br/>
                                          {item.actor_type === 'user' ? (
                                            <span>Button - Selected Option - {item.content.buttons.map(button => button.text).join(", ")}</span>
                                          ) : (
                                            <span>Button - Options - {item.content.buttons.map(button => button.text).join(", ")}</span>
                                          )}
                                        </div>
                                      )
                                    }
                                  </div>
                                )
                                      })
                                    }
                            </div>
                          </div>
                          
              </div>
            )}
          </div>
        ))}
        {
          loading && (<div className="flex justify-center items-center" style={{ height: "88%", flexDirection: "column" }}>
            <div className="loader"></div>
            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
          </div>)
        }
        </div>
      </div>
    </div>
  );
};

export default LeadQualityConfigure;
